import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

type Product = {
    id: string;
    name: string;
    description: string;
    price: number;
    quantity: number;
    type:string,
    status:string,
    brandId:string,
    productImages: ProductImage[];
    variantTypes: any;
    createDate: string,
}
type ProductImage = {
    imageUrl: string;
    id: number;
}

export async function AddProduct(id: any) {
    const response = await axios.post(`${getEndpoint()}/api/Product/Add`, id, ngrokSkipWarning);
    return response.data;
}

export async function GetAllProducts() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAll`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllShirts() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAllShirts`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllShoes() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAllShoes`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllPants() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAllPants`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllAccessories() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAllAccessories`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllBags() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAllBags`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllWatches() {
    const respone = await axios.get(`${getEndpoint()}/api/Product/GetAllWatches`, ngrokSkipWarning);
    return respone.data;
}

export async function GetAllProductsWithImages(){
    const response = await axios.get(`${getEndpoint()}/api/Product/GetAllWithImages`, ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function GetProductsWithImages(id: any){
    const response = await axios.get(`${getEndpoint()}/api/Product/GetWithAttributes?id=${id}`, ngrokSkipWarning);
    return response.data;
}

export async function UpdateProductInfo(id: any) {
    const response = await axios.put(`${getEndpoint()}/api/Product/Update`, id, ngrokSkipWarning);
    return response.data;
}

export async function DeleteProduct(id: string) {
    const response = await axios.delete(`${getEndpoint()}/api/Product/Delete?id=${id}`, ngrokSkipWarning);
    return response.data;
}

export async function AddProductImage(id: any) {
    const response = await axios.post(`${getEndpoint()}/api/ProductImage/Add`, id, {headers: {"accept": "application/json", 
                                      "content-type": "multipart/form-data"} });
    return response.data;
}

export async function UpdateProductImage(dto: any) {
    try {
        const response = await axios.put(`${getEndpoint()}/api/ProductImage/Update`, dto, ngrokSkipWarning);
        return response.data;
    } catch (error) {
        console.error("Error updating product image:", error);
        throw error;
    }
}

export async function CompareProducts(productId1: string, productId2: string): Promise<Product[]> {
    try {
        const response = await axios.get(`${getEndpoint()}/api/Product/Compare?productId1=${productId1}&productId2=${productId2}`, ngrokSkipWarning);
        return response.data;
    } catch (error) {
        console.error('Error comparing products:', error);
        throw error;
    }
}